export default __webpack_public_path__ + "static/media/65.5a05312a.jpg";